import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { FAIcon } from "../core/components/faIcon";
import { General } from "../../siteManagement/general";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { Dialog } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { BaseComponentProps, BaseField } from "../core/components/baseComponentProps";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
//https://stackoverflow.com/questions/35016499/how-do-i-create-kendo-combobox-with-multiple-selected-items-using-server-filteri
export default class EmailSelector extends React.Component<EmailSelectorProps, EmailSelectorState>{
    private locked: boolean = false;
    private multiSelectRef: HTMLSelectElement;
    private multiSelect: kendo.ui.MultiSelect;
    private translations: StringKeyDictionary<string>;
    private types = {
        1: "User",
        2: "Contact (business)",
        3: "Contact (private)",
        4: "Address",
        5: "Resource"
    };
    private unknown = -1;

    constructor(props: EmailSelectorProps) {
        super(props)
        this.state = {
            values: []
        }
        this.initApp();
    }

    private initApp = async () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.command === "triggerUpdateEmail") {
                this.updateMails();
            }
        })
        let mails: string[] = [];
        if (!Helper.isNullOrEmpty(this.props.value)) {
            mails = this.props.value.split(",").map((email) => email.trim());
        }
        const [translations, emails] = await Promise.all([
            Helper.getTranslations(["WebCRM.Tasks.ExecuteAll.Unknown",
                "Server.User",
                "BrowserTitle.Contact.Available",
                "Adresse.Ansprechpartner",
                "BrowserTitle.Resource.Available",
                "WebCRM.Email.AddMailToSystem"
            ]),
            this.getMails(mails)
        ]);
        setTimeout(() => {
            this.translations = translations.Data;
            this.setState({ values: emails }, () => {
                this.addValues(emails);
            })
        }, 400)
    }

    private getMails = async (mails: string[]) => {
        const mailsToUpdate = this.getMailsToUpdate(mails);
        if (mailsToUpdate.length === 0 || this.locked)
            return [];
        this.locked = true;
        const result = await HTTPService.noBusyIndicator().post<EmailLookUp[]>("EmailSender/GetAllAvailableMails", {
            mails: mailsToUpdate,
            jobId: this.props.context.keyVal1
        });
        this.locked = false;
        return result;
    }

    private addValues = (data: EmailLookUp[], callBack: (values: EmailLookUp[]) => void = null) => {
        const values = this.state.values
            .concat(data)
            .filter((item: EmailLookUp, index: number, self: EmailLookUp[]) => {
                return self.findIndex(f => f.Email.toLowerCase() === item.Email.toLowerCase()) === index;
            });
        if (Helper.hasValue(this.multiSelect)) {
            this.multiSelect.dataSource.data(values);
            this.multiSelect.value(values.map(f => { return f.Email }));
            this.multiSelect.trigger("change");
            if (Helper.hasValue(callBack)) {
                callBack(values);
            }
        }
    }

    componentDidMount() {
        this.build();
    }

    componentDidUpdate(prevProps: EmailSelectorProps) {
        if (prevProps.disabled !== this.props.disabled) {
            this.multiSelect.enable(!this.props.disabled)
        }
    }

    private updateMails = async () => {
        const mails = this.getMailsToUpdate((Helper.isNullOrEmpty(this.props.value) ? "" : this.props.value).split(","));
        if (mails.length > 0) {
            const lookUps = await this.getMails(mails);
            this.addValues(lookUps);
        }
    }

    private getMailsToUpdate = (mails: string[]) => {
        return (Helper.hasValue(mails) ? mails : []).filter((item) => {
            const index = this.state.values.findIndex(f => f.Email.toLowerCase() == item.toLowerCase());
            return index === -1 && !Helper.isNullOrEmpty(item);
        })
    }

    private build = () => {
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            enable: !this.props.disabled,
            noDataTemplate: Helper.getValueOrDefault(this.props.field.noDataTemplate, false),
            dataTextField: "Name",
            dataValueField: "Email",
            filter: "contains",
            clearButton: false,
            tagTemplate: this.props.field.tagTemplate,
            itemTemplate: this.props.field.itemTemplate,
            select: async (ev) => {
                const dataItem: EmailLookUp = ev.dataItem;
                const values = this.state.values;
                values.push({
                    Email: dataItem.Email,
                    Name: dataItem.Name,
                    Type: dataItem.Type,
                    TypeDesignation: dataItem.TypeDesignation
                });
                this.setState({ values: values }, () => {
                    this.props.onChange(this.props.field, values.map((i) => { return i.Email }).join(","), values)
                })
            },
            deselect: async (ev) => {
                const dataItem = ev.dataItem as EmailLookUp;
                const values = this.state.values.filter((item) => {
                    return dataItem.Email != item.Email;
                })
                this.setState({ values: values }, () => {
                    this.props.onChange(this.props.field, values.map((i) => { return i.Email }).join(","), values)
                })
            },
            dataSource: {
                type: "json",
                serverFiltering: true,
                transport: {
                    read: {
                        url: `${Config.baseUrl}EmailSender/PossibleMails`,
                        dataType: "json",
                        data: () => {
                            return {
                                search: $(this.multiSelectRef).data("kendoMultiSelect").input.val()
                            }
                        }
                    }
                },
                schema: {
                    type: "json",
                    data: "Data",
                    model: {
                        fields: {
                            Name: { field: "Name", type: "string" },
                            Email: { field: "Email", type: "string" }
                        }
                    }
                }
            }
        }).data("kendoMultiSelect");
    }

    private renderSearch = (info: SearchInfo, index: number) => {
        const search = () => {
            const sheet = General.Sheet.Manager.createSheetWithUrl(info.url);
            sheet.bind(SheetEventType.ItemsSelected, (data: { data: any[] }) => {
                const mails: EmailLookUp[] = data
                    .data
                    .filter(item => !Helper.isNullOrEmpty(item[info.emailField]))
                    .map((item) => {
                        return {
                            Email: item[info.emailField],
                            Name: item[info.nameField],
                            Type: info.type,
                            TypeDesignation: this.types[info.type]
                        }
                    })
                this.addValues(mails, (newMails) => {
                    const values = this.state.values;
                    newMails.forEach((mail) => {
                        values.push(mail);
                    });
                    this.setState({ values: values }, () => {
                        this.props.onChange(this.props.field, values.map((i) => { return i.Email }).join(","), values)
                    })
                });
            })
            sheet.bind(SheetEventType.SetSelectedItems, (callback) => {
                if (Helper.hasValue(callback)) {
                    const data = this.state.values
                        .filter(f => f.Type == info.type)
                        .map((item) => {
                            return {
                                [info.nameField]: item.Name,
                                [info.emailField]: item.Email
                            }
                        })
                    callback(data);
                }
            })
        }

        return (
            <div key={kendo.guid()} className={"email__button"} title={Helper.isNullOrEmpty(info.title) ? "" : info.title} onClick={search} style={{  }}>
                <FAIcon name={info.icon} attributes={["lg"]} />
            </div>
        );
    }

    private renderSearches = () => {
        if (Helper.hasValue(this.props.field.searches)) {
            const infoIsValid = (info: SearchInfo) => {
                return !Helper.isNullOrEmpty(info.emailField) && !Helper.isNullOrEmpty(info.nameField) && !Helper.isNullOrEmpty(info.icon) && !Helper.isNullOrEmpty(info.url) && Helper.isNumber(info.type) && info.type > -1;
            }
            return (
                <>
                    <div style={{ display: "flex" }}>
                        {
                            this.props.field.searches.map((info, index) => {
                                return (
                                    <React.Fragment key={Helper.getHashCode(JSON.stringify(info))}>
                                        {infoIsValid(info) ? this.renderSearch(info, index) : null}
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                </>
            );
        } else {
            return null;
        }
    }

    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <>
                <style>
                    {`.email__button{
                        border: 1px solid #ced4da; 
                        height: 38px;
                        width:  34px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        border-width: 1px 1px 1px 0; 
                    }

                    .email__button:last-child{
                        border-radius: var(--rounded-right)
                    }

                    .k-multiselect{
                        border-radius: var(--rounded-left)
                    }

                    `
                        
                    }
                </style>
                <div style={{ display: "flex" }}>

                    <div style={{ width: "100%" }}>
                        <select ref={(ref) => this.multiSelectRef = ref} style={style} data-label={this.props.field.name} />
                    </div>
                    {this.props.disabled ? null : this.renderSearches()}
                </div>
            </>
        );
    }
}

export interface EmailSelectorProps extends BaseComponentProps {
    value: string;
    field: EmailSelectorField;
    context: {
        keyVal1: number;
    }
}

interface EmailSelectorField extends BaseField {
    noDataTemplate: boolean | string;
    searches: SearchInfo[];
    tagTemplate: string;
    itemTemplate: string;
}

interface SearchInfo {
    emailField: string;
    icon: string;
    nameField: string;
    type: number;
    url: string;
    title?: string;
}

interface EmailSelectorState {
    values: EmailLookUp[]
}

export interface EmailLookUp {
    Name: string;
    Email: string;
    Type: number;
    TypeDesignation?: string;
}